/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free word frequency counter. Paste text and see which words appear most often, ranked with counts and bars. Set a minimum word length and top-N. Works in your browser.`)
};

const es_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de frecuencia de palabras gratuito. Pega texto y ve qué palabras aparecen más a menudo, ordenadas con conteos y barras. Establece una longitud mínima de palabra y top-N. Funciona en tu navegador.`)
};

const de_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Wortfrequenzzähler. Text einfügen und sehen, welche Wörter am häufigsten vorkommen, sortiert mit Anzahl und Balken. Minimale Wortlänge und Top-N einstellbar. Funktioniert direkt im Browser.`)
};

const nl_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis woordfrequentieteller. Plak tekst in en zie welke woorden het meest voorkomen, gerangschikt met aantallen en balken. Stel een minimale woordlengte en top-N in. Werkt in uw browser.`)
};

const fr_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de fréquence des mots gratuit. Collez du texte et voyez quels mots apparaissent le plus souvent, classés avec des compteurs et des barres. Définissez une longueur minimale de mots et un top-N. Fonctionne dans votre navigateur.`)
};

const it_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di frequenza delle parole gratuito. Incolla il testo e vedi quali parole appaiono più spesso, classificate con conteggi e barre. Imposta una lunghezza minima della parola e top-N. Funziona nel tuo browser.`)
};

const pt_br2_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de frequência de palavras gratuito. Cole texto e veja quais palavras aparecem com mais frequência, classificadas com contagens e barras. Defina um comprimento mínimo de palavra e top-N. Funciona no seu navegador.`)
};

const pt_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de frequência de palavras gratuito. Cole o texto e veja quais palavras aparecem mais vezes, classificadas com contagens e barras. Defina um comprimento mínimo de palavra e top-N. Funciona no seu navegador.`)
};

const ja_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の単語頻度カウンター。テキストを貼り付けて、最も頻繁に出現する単語を確認し、カウント数とバーでランク付けされています。最小単語長と上位Nを設定します。ブラウザで動作します。`)
};

const zh_wf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的词频统计工具。粘贴文本，查看出现频率最高的单词，并以计数和条形图排名显示。可设置最小单词长度和显示数量（top-N）。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_meta_description", locale)
	if (locale === "en") return en_wf_meta_description(inputs)
	if (locale === "es") return es_wf_meta_description(inputs)
	if (locale === "de") return de_wf_meta_description(inputs)
	if (locale === "nl") return nl_wf_meta_description(inputs)
	if (locale === "fr") return fr_wf_meta_description(inputs)
	if (locale === "it") return it_wf_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_wf_meta_description(inputs)
	if (locale === "pt") return pt_wf_meta_description(inputs)
	if (locale === "ja") return ja_wf_meta_description(inputs)
	return zh_wf_meta_description(inputs)
};